import React, { useState } from 'react'
import { Card, Table } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'

type Props = {
  plans: any
}

const ComparePlan: React.FC<Props> = ({ plans }) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  // Extract all unique feature keys from the plans
  const featureNames = Array.from(new Set(plans.flatMap((plan: any) => Object.keys(plan.features))))
  const formatFeatureKey = (key: string) => {
    if (key === 'additionalChannelntegration') {
      return 'Additional Channel Integration'
    }
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/C R M/, 'CRM')
  }

  const style = {
    transform: `scale(${isHovered ? '1.025' : '1'})`,
    transition: 'transform 0.2s ease-in-out',
    boxShadow: isHovered ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'
  }
  return (
    <>
      <Card className='bg-white p-5 rounded-lg shadow subscription-card' style={style}>
        <header className='text-center mb-5'>
          <h1>Compare Plan</h1>
        </header>
        <Table bordered striped hover>
          <thead>
            <tr>
              <th>FEATURES</th>
              {plans.map((plan: any, index: number) => (
                <th key={uuidv4()}>{plan.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {featureNames.map((featureKey: any, index: any) => (
              <tr key={uuidv4()}>
                <td>{formatFeatureKey(featureKey)}</td>
                {plans.map((plan: any) => {
                  const feature = plan.features[featureKey]
                  let renderedFeature

                  if (typeof feature === 'boolean') {
                    renderedFeature = feature ? (
                      <span className='text-success'>&#10004;</span>
                    ) : (
                      <span className='text-danger'>&#10008;</span>
                    )
                  } else {
                    renderedFeature = feature
                  }

                  return <td key={plan.id || plan.name}>{renderedFeature}</td>
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  )
}

export default ComparePlan
